import { useList } from '@refinedev/core';
import { FormStickyActions, FormSpacer } from '@/components/forms';
import {
  LanguageSwitcher,
  type TranslationLanguage,
  type LanguageCode,
} from '@/components/translations';
import { CourseFormFields, initFormState, type FormState } from './CourseFormFields';
import { buildTeacherOptions, type TeacherRecord } from './select-utils';
import type { CourseFormData } from '../types';

const TRANSLATION_FIELDS = [
  { name: 'title', label: 'Название курса', type: 'input' as const, required: true },
  { name: 'shortDescription', label: 'Краткое описание', type: 'richtext' as const },
  { name: 'description', label: 'Полное описание', type: 'richtext' as const },
];

interface CourseCreateEditTabProps {
  loading: boolean;
  languages: TranslationLanguage[];
  onFinish: (v: Partial<CourseFormData>) => Promise<void>;
}

export function CourseCreateEditTab({ loading, languages, onFinish }: CourseCreateEditTabProps) {
  const { result: instrResult, query: instrQ } = useList<TeacherRecord>({
    resource: 'teachers',
    pagination: { pageSize: 100 },
    filters: [{ field: 'isActive', operator: 'eq', value: true }],
  });
  const instrOpts = buildTeacherOptions(instrResult?.data ?? []);

  const isLoading = loading || instrQ.isLoading;
  const initial = initFormState();

  return (
    <CourseFormFields
      key="create"
      isEdit={false}
      loading={isLoading}
      initial={initial}
      instrOpts={instrOpts}
      languages={languages}
      renderHeader={(state: FormState, setField) => (
        <div className="flex items-center justify-end gap-3">
          {languages.length > 0 && (
            <LanguageSwitcher
              languages={languages}
              activeLanguage={state.lang}
              onLanguageChange={(c) => setField('lang', c as LanguageCode)}
              fields={TRANSLATION_FIELDS}
              value={state.translations}
              variant="compact"
            />
          )}
        </div>
      )}
      renderFooter={(submit, isPending) => (
        <>
          <FormSpacer />
          <form onSubmit={(e) => { e.preventDefault(); submit(); }}>
            <FormStickyActions
              primaryLabel="Создать"
              onPrimary={submit}
              isPending={isPending}
              pendingLabel="Создание..."
            />
          </form>
        </>
      )}
      onSubmit={async (data) => {
        await onFinish(data);
      }}
    />
  );
}
